import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './img/df_image.png'


const _withScopeId = n => (_pushScopeId("data-v-053dca4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "df-image-box"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "title-style-box"
}
const _hoisted_5 = ["src", "onLoad"]
const _hoisted_6 = {
  key: 0,
  class: "title-style-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_ctx.modelValue.list.length == 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "item-container",
        style: _normalizeStyle(_ctx.wrapStyle)
      }, _hoisted_2, 4))
    : (_ctx.modelValue.orderMode == 'oneline')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "item-container",
          style: _normalizeStyle(_ctx.wrapStyle)
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle(_ctx.listWapStyle)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "image-list-item-box",
                style: _normalizeStyle(_ctx.listStyle)
              }, [
                _createElementVNode("img", {
                  src: item.image,
                  class: "image-style-box"
                }, null, 8, _hoisted_3),
                (item.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.title), 1))
                  : _createCommentVNode("", true)
              ], 4))
            }), 128))
          ], 4)
        ], 4))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "carousel-container",
          style: _normalizeStyle(_ctx.wrapStyle)
        }, [
          _createVNode(_component_el_carousel, {
            trigger: "click",
            height: _ctx.carouselHeight,
            ref: "warpBox"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.list, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  key: 'item.image' + index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "image-list-item-box",
                      style: _normalizeStyle(_ctx.listStyle)
                    }, [
                      _createElementVNode("img", {
                        src: item.image,
                        onLoad: ($event: any) => (_ctx.loadImage($event, index)),
                        class: "image-style-box"
                      }, null, 40, _hoisted_5),
                      (item.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.title), 1))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["height"])
        ], 4))
}